import React from 'react';
import { useTranslation } from 'react-i18next';

const Unauthorized = () => {
  const { t } = useTranslation('global');
  return (
    <div>
      <h1>{t('unauthorized.title')}</h1>
      <p>{t('unauthorized.message')}</p>      
    </div>
  );
};

export default Unauthorized;